import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_pd_cheque_pending_processing_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    source_document_type: fromDatatype.VarcharDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    cash_document_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cash_document_line_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    payment_method_type_guid: fromDatatype.GuidDataFieldInterface;
    payment_method_type_code: fromDatatype.VarcharDatatypeInterface;
    payee_payor: fromDatatype.VarcharDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    cheque_date: fromDatatype.TimestampTzDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
    wf_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_pd_cheque_pending_processing_queue_RowClass implements bl_fi_pd_cheque_pending_processing_queue_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    source_document_type: fromDatatype.VarcharDatatypeInterface;
    gen_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    gen_doc_line_guid: fromDatatype.GuidDataFieldInterface;
    cash_document_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cash_document_line_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_guid: fromDatatype.GuidDataFieldInterface;
    payment_method_type_guid: fromDatatype.GuidDataFieldInterface;
    payment_method_type_code: fromDatatype.VarcharDatatypeInterface;
    payee_payor: fromDatatype.VarcharDatatypeInterface;
    transaction_no: fromDatatype.VarcharDatatypeInterface;
    cheque_date: fromDatatype.TimestampTzDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
    wf_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
    wf_process_resolution_code: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}